import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import Layout from '../Layout';
import Seo from '../component/Seo';
import { langPathSuffix } from '../lang-utils';
import Contact from '../component/ContactSection';

const SEO = {
  lt: {
    title: 'Kontaktai – tralo paslaugos Kaune 24/7 | Geltonas Traliukas',
    description: 'Susisiekite su mumis dėl tralo paslaugų Kaune ir visoje Lietuvoje. Telefonas +370 67304727, el. paštas kaunetraliukas@gmail.com. Dirbame 24/7.',
    h1: 'Kontaktai',
    intro: 'Susisiekite su mumis bet kuriuo paros metu – dirbame 24 valandas per parą, 7 dienas per savaitę. Greitai atsakome į telefono skambučius ir žinutes.',
    crossTitle: 'Daugiau informacijos',
    crossService: 'Mūsų paslaugos',
    crossFaq: 'DUK',
    crossGallery: 'Darbų galerija'
  },
  en: {
    title: 'Contacts – tow truck services in Kaunas 24/7 | Geltonas Traliukas',
    description: 'Contact us for tow truck services in Kaunas and Lithuania. Phone +370 67304727, email kaunetraliukas@gmail.com. We work 24/7.',
    h1: 'Contacts',
    intro: 'Contact us any time of day – we work 24 hours a day, 7 days a week. We respond quickly to calls and messages.',
    crossTitle: 'More information',
    crossService: 'Our services',
    crossFaq: 'FAQ',
    crossGallery: 'Work gallery'
  },
  ru: {
    title: 'Контакты – услуги эвакуатора в Каунасе 24/7 | Geltonas Traliukas',
    description: 'Свяжитесь с нами для услуг эвакуатора в Каунасе и по всей Литве. Телефон +370 67304727, e-mail kaunetraliukas@gmail.com. Работаем 24/7.',
    h1: 'Контакты',
    intro: 'Свяжитесь с нами в любое время — работаем 24 часа в сутки, 7 дней в неделю. Быстро отвечаем на звонки и сообщения.',
    crossTitle: 'Больше информации',
    crossService: 'Наши услуги',
    crossFaq: 'FAQ',
    crossGallery: 'Галерея работ'
  }
};

function KontaktaiPage({ lang = 'lt' }) {
  const t = SEO[lang] || SEO.lt;
  return (
    <Layout
      lang={lang}
      renderChildren={({ strings, pageWidth, onTop }) => {
        return (
          <>
            <Seo path="/kontaktai/" lang={lang} title={t.title} description={t.description} pageName={strings.navbar.contact} />
            <Container className="section-padding">
              <div className="text-center">
                <h1 className="section-title">{t.h1}</h1>
                <div className="section-underline" />
              </div>
              <p className="text-justify page-intro">{t.intro}</p>
            </Container>
            <Contact strings={strings} onTop={onTop} pageWidth={pageWidth} section="dark" hideTitle />
            <Container className="section-padding">
              <h2 className="text-center">{t.crossTitle}</h2>
              <ul className="cross-links">
                <li><Link to={`/paslaugos/${langPathSuffix(lang)}`}>{t.crossService}</Link></li>
                <li><Link to={`/duk/${langPathSuffix(lang)}`}>{t.crossFaq}</Link></li>
                <li><Link to={`/galerija/${langPathSuffix(lang)}`}>{t.crossGallery}</Link></li>
              </ul>
            </Container>
          </>
        );
      }}
    />
  );
}

export default KontaktaiPage;
